import { render, staticRenderFns } from "./FailedView.vue?vue&type=template&id=ecfb8018&scoped=true&"
import script from "./FailedView.vue?vue&type=script&lang=js&"
export * from "./FailedView.vue?vue&type=script&lang=js&"
import style0 from "./FailedView.vue?vue&type=style&index=0&id=ecfb8018&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecfb8018",
  null
  
)

export default component.exports